module.exports = __webpack_public_path__ + "img/work-card2.2cc632b8.png";